import { PageOptions } from "@/contexts/DashboardStateContext";
import { useHasStations } from "@gettactic/hooks";
import { TabsList, TabsTrigger } from "@v2/components/ui/tabs";
import { cn } from "@v2/lib/utils";
import { ArrowLeftIcon } from "lucide-react";
import React, { useMemo } from "react";
export interface IDashboardTabsListProps {
  selectedEvent: string;
  setSelectedEvent: (event: string | null) => void;
  isAdmin: boolean;
  hasPages: number | boolean | undefined;
  showAttendanceTab: boolean;
  setPage: (page: PageOptions) => void;
  defaultPage: PageOptions;
  isMobile?: boolean;
}

export const DashboardTabsList: React.FC<IDashboardTabsListProps> = ({
  selectedEvent,
  setSelectedEvent,
  setPage,
  isAdmin,
  hasPages,
  showAttendanceTab,
  defaultPage,
  isMobile = false
}) => {
  const { hasStations } = useHasStations();

  const positions = useMemo(() => {
    // we show alternative order for users that have privacy enabled
    const alternativeOrder = !showAttendanceTab && !selectedEvent && !isMobile;
    return {
      siteInfo: alternativeOrder ? 0 : 3,
      attendance: alternativeOrder ? 1 : 0,
      visitors: alternativeOrder ? 2 : 1,
      news: alternativeOrder ? 3 : 2
    };
  }, [showAttendanceTab, selectedEvent, isMobile]);

  return (
    <TabsList
      className={cn(
        "w-full justify-center md:mt-3 md:mb-4",
        "items-center md:items-start",
        "justify-start"
      )}
      showTabsAsDropdownInMobile
    >
      {Boolean(showAttendanceTab || selectedEvent || isMobile) && (
        <TabsTrigger
          variant={selectedEvent ? "default" : "minimalistic"}
          className={cn(
            selectedEvent ? " mb-2.5 pr-0" : isMobile ? "pb-0" : "pb-2",
            `order-${positions.attendance}`
          )}
          value="schedules"
          onClick={
            selectedEvent
              ? () => {
                  setSelectedEvent(null);

                  // will be Attendance or SiteInfo (if privacy is enabled)
                  setPage(defaultPage);
                }
              : undefined
          }
        >
          {selectedEvent ? (
            <span className="flex items-center gap-2">
              <ArrowLeftIcon className="size-4" />
              Back{" "}
            </span>
          ) : (
            "Schedules"
          )}
        </TabsTrigger>
      )}
      {Boolean(!selectedEvent && isAdmin && hasStations) && (
        <TabsTrigger
          variant="minimalistic"
          value="visitors"
          className={`order-${positions.visitors}`}
        >
          Visitors
        </TabsTrigger>
      )}
      {!selectedEvent && (
        <TabsTrigger
          variant="minimalistic"
          value="news"
          className={`order-${positions.news}`}
        >
          News
        </TabsTrigger>
      )}
      {Boolean(!selectedEvent && hasPages) && (
        <TabsTrigger
          variant="minimalistic"
          value="siteInfo"
          className={`order-${positions.siteInfo}`}
        >
          Site Info
        </TabsTrigger>
      )}
    </TabsList>
  );
};
